// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file gitpod/v1/insights.proto (package gitpod.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_gitpod_tools_v1_logfields } from "../tools/v1/logfields_pb";
import type { SupportedModel } from "./agent_pb";
import { file_gitpod_v1_agent } from "./agent_pb";
import type { CoAuthorTool } from "./usage_pb";
import { file_gitpod_v1_usage } from "./usage_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gitpod/v1/insights.proto.
 */
export const file_gitpod_v1_insights: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_gitpod_tools_v1_logfields, file_gitpod_v1_agent, file_gitpod_v1_usage, file_google_protobuf_timestamp]);

/**
 * CommitCoAuthorStat represents co-author data for a single commit.
 *
 * @generated from message gitpod.v1.CommitCoAuthorStat
 */
export type CommitCoAuthorStat = Message<"gitpod.v1.CommitCoAuthorStat"> & {
  /**
   * SHA of the commit. Used with project_id as the idempotency key.
   *
   * @generated from field: string commit_hash = 1;
   */
  commitHash: string;

  /**
   * Author date of the commit.
   *
   * @generated from field: google.protobuf.Timestamp commit_date = 2;
   */
  commitDate?: Timestamp;

  /**
   * Which tool co-authored this commit, NO_COAUTHOR for solo commits,
   * or HUMAN_COAUTHOR for human pair-programming.
   * UNSPECIFIED is rejected — callers must always set a concrete value.
   *
   * @generated from field: gitpod.v1.CoAuthorTool tool = 3;
   */
  tool: CoAuthorTool;

  /**
   * Lines added in this commit.
   *
   * @generated from field: int64 lines_added = 4;
   */
  linesAdded: bigint;

  /**
   * Lines removed in this commit.
   *
   * @generated from field: int64 lines_removed = 5;
   */
  linesRemoved: bigint;

  /**
   * One-way hash of the author email. Enables distinct author counts
   * without storing PII.
   *
   * @generated from field: string author_hash = 6;
   */
  authorHash: string;

  /**
   * Raw co-author email address from the Co-authored-by trailer.
   * Empty when there is no co-author trailer. Stored verbatim so the
   * backend can reclassify historical data when new AI tools are added.
   *
   * @generated from field: string raw_coauthor = 7;
   */
  rawCoauthor: string;
};

/**
 * Describes the message gitpod.v1.CommitCoAuthorStat.
 * Use `create(CommitCoAuthorStatSchema)` to create a new message.
 */
export const CommitCoAuthorStatSchema: GenMessage<CommitCoAuthorStat> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 0);

/**
 * ReportCoAuthorStatsRequest is sent by the CLI to push analysis results.
 *
 * @generated from message gitpod.v1.ReportCoAuthorStatsRequest
 */
export type ReportCoAuthorStatsRequest = Message<"gitpod.v1.ReportCoAuthorStatsRequest"> & {
  /**
   * Project that was analyzed.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Per-commit co-author stats to upsert. May be empty to act as a
   * heartbeat that updates last_workflow_run without persisting data.
   *
   * @generated from field: repeated gitpod.v1.CommitCoAuthorStat stats = 2;
   */
  stats: CommitCoAuthorStat[];
};

/**
 * Describes the message gitpod.v1.ReportCoAuthorStatsRequest.
 * Use `create(ReportCoAuthorStatsRequestSchema)` to create a new message.
 */
export const ReportCoAuthorStatsRequestSchema: GenMessage<ReportCoAuthorStatsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 1);

/**
 * @generated from message gitpod.v1.ReportCoAuthorStatsResponse
 */
export type ReportCoAuthorStatsResponse = Message<"gitpod.v1.ReportCoAuthorStatsResponse"> & {
  /**
   * Number of rows inserted (new commits).
   *
   * @generated from field: int64 inserted_count = 1;
   */
  insertedCount: bigint;

  /**
   * Number of rows updated (re-reported commits).
   *
   * @generated from field: int64 updated_count = 2;
   */
  updatedCount: bigint;
};

/**
 * Describes the message gitpod.v1.ReportCoAuthorStatsResponse.
 * Use `create(ReportCoAuthorStatsResponseSchema)` to create a new message.
 */
export const ReportCoAuthorStatsResponseSchema: GenMessage<ReportCoAuthorStatsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 2);

/**
 * EnableProjectInsightsRequest enables co-author insights for a project.
 *
 * @generated from message gitpod.v1.EnableProjectInsightsRequest
 */
export type EnableProjectInsightsRequest = Message<"gitpod.v1.EnableProjectInsightsRequest"> & {
  /**
   * Project to enable insights for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.EnableProjectInsightsRequest.
 * Use `create(EnableProjectInsightsRequestSchema)` to create a new message.
 */
export const EnableProjectInsightsRequestSchema: GenMessage<EnableProjectInsightsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 3);

/**
 * @generated from message gitpod.v1.EnableProjectInsightsResponse
 */
export type EnableProjectInsightsResponse = Message<"gitpod.v1.EnableProjectInsightsResponse"> & {
};

/**
 * Describes the message gitpod.v1.EnableProjectInsightsResponse.
 * Use `create(EnableProjectInsightsResponseSchema)` to create a new message.
 */
export const EnableProjectInsightsResponseSchema: GenMessage<EnableProjectInsightsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 4);

/**
 * DisableProjectInsightsRequest disables co-author insights for a project.
 *
 * @generated from message gitpod.v1.DisableProjectInsightsRequest
 */
export type DisableProjectInsightsRequest = Message<"gitpod.v1.DisableProjectInsightsRequest"> & {
  /**
   * Project to disable insights for.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.DisableProjectInsightsRequest.
 * Use `create(DisableProjectInsightsRequestSchema)` to create a new message.
 */
export const DisableProjectInsightsRequestSchema: GenMessage<DisableProjectInsightsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 5);

/**
 * @generated from message gitpod.v1.DisableProjectInsightsResponse
 */
export type DisableProjectInsightsResponse = Message<"gitpod.v1.DisableProjectInsightsResponse"> & {
};

/**
 * Describes the message gitpod.v1.DisableProjectInsightsResponse.
 * Use `create(DisableProjectInsightsResponseSchema)` to create a new message.
 */
export const DisableProjectInsightsResponseSchema: GenMessage<DisableProjectInsightsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 6);

/**
 * GetProjectInsightsStatusRequest checks whether insights is enabled for a project.
 *
 * @generated from message gitpod.v1.GetProjectInsightsStatusRequest
 */
export type GetProjectInsightsStatusRequest = Message<"gitpod.v1.GetProjectInsightsStatusRequest"> & {
  /**
   * Project to check.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;
};

/**
 * Describes the message gitpod.v1.GetProjectInsightsStatusRequest.
 * Use `create(GetProjectInsightsStatusRequestSchema)` to create a new message.
 */
export const GetProjectInsightsStatusRequestSchema: GenMessage<GetProjectInsightsStatusRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 7);

/**
 * @generated from message gitpod.v1.GetProjectInsightsStatusResponse
 */
export type GetProjectInsightsStatusResponse = Message<"gitpod.v1.GetProjectInsightsStatusResponse"> & {
  /**
   * Whether co-author insights is enabled for the project.
   *
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * When the insights workflow last completed successfully.
   * Nil when enabled is true but no data has been collected yet (pending state).
   *
   * @generated from field: google.protobuf.Timestamp last_ran_at = 2;
   */
  lastRanAt?: Timestamp;
};

/**
 * Describes the message gitpod.v1.GetProjectInsightsStatusResponse.
 * Use `create(GetProjectInsightsStatusResponseSchema)` to create a new message.
 */
export const GetProjectInsightsStatusResponseSchema: GenMessage<GetProjectInsightsStatusResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 8);

/**
 * ReportAgentTraceRequest pushes an agent trace session containing one or more
 * trace lines (typically JSONL) for storage.
 *
 * @generated from message gitpod.v1.ReportAgentTraceRequest
 */
export type ReportAgentTraceRequest = Message<"gitpod.v1.ReportAgentTraceRequest"> & {
  /**
   * Project the trace belongs to.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Environment that produced the trace.
   *
   * @generated from field: string environment_id = 2;
   */
  environmentId: string;

  /**
   * Agent execution that produced the trace.
   *
   * @generated from field: string agent_execution_id = 3;
   */
  agentExecutionId: string;

  /**
   * Total lines added across all edits in the trace session.
   *
   * @generated from field: int64 lines_added = 4;
   */
  linesAdded: bigint;

  /**
   * Total lines removed across all edits in the trace session.
   *
   * @generated from field: int64 lines_removed = 5;
   */
  linesRemoved: bigint;

  /**
   * The LLM model used during this agent session.
   *
   * @generated from field: gitpod.v1.SupportedModel model = 7;
   */
  model: SupportedModel;

  /**
   * Individual trace lines (typically one JSON object per line).
   * May be empty when only line-count aggregates are reported.
   * Each line is capped at 5 MiB.
   *
   * @generated from field: repeated string traces = 6;
   */
  traces: string[];
};

/**
 * Describes the message gitpod.v1.ReportAgentTraceRequest.
 * Use `create(ReportAgentTraceRequestSchema)` to create a new message.
 */
export const ReportAgentTraceRequestSchema: GenMessage<ReportAgentTraceRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 9);

/**
 * @generated from message gitpod.v1.ReportAgentTraceResponse
 */
export type ReportAgentTraceResponse = Message<"gitpod.v1.ReportAgentTraceResponse"> & {
};

/**
 * Describes the message gitpod.v1.ReportAgentTraceResponse.
 * Use `create(ReportAgentTraceResponseSchema)` to create a new message.
 */
export const ReportAgentTraceResponseSchema: GenMessage<ReportAgentTraceResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 10);

/**
 * PullRequestStat represents speed metrics for a single merged pull request.
 *
 * @generated from message gitpod.v1.PullRequestStat
 */
export type PullRequestStat = Message<"gitpod.v1.PullRequestStat"> & {
  /**
   * PR/MR number from the SCM provider. Together with project_id forms the
   * idempotency key for upserts.
   *
   * @generated from field: int32 pr_number = 1;
   */
  prNumber: number;

  /**
   * Raw SCM username of the PR author (e.g. GitHub user.login, GitLab author.username).
   *
   * @generated from field: string author_login = 2;
   */
  authorLogin: string;

  /**
   * When the PR was opened.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 3;
   */
  createdAt?: Timestamp;

  /**
   * When the PR was merged.
   *
   * @generated from field: google.protobuf.Timestamp merged_at = 4;
   */
  mergedAt?: Timestamp;

  /**
   * Author date of the earliest commit on the PR branch.
   *
   * @generated from field: google.protobuf.Timestamp first_commit_at = 5;
   */
  firstCommitAt?: Timestamp;

  /**
   * Timestamp of the earliest approving review. Unset when the PR had no approvals.
   *
   * @generated from field: google.protobuf.Timestamp first_approval_at = 6;
   */
  firstApprovalAt?: Timestamp;

  /**
   * Branch the PR was merged into (e.g. "main").
   *
   * @generated from field: string target_branch = 7;
   */
  targetBranch: string;

  /**
   * SCM platform the PR was fetched from.
   *
   * @generated from field: gitpod.v1.ScmProvider scm_provider = 8;
   */
  scmProvider: ScmProvider;
};

/**
 * Describes the message gitpod.v1.PullRequestStat.
 * Use `create(PullRequestStatSchema)` to create a new message.
 */
export const PullRequestStatSchema: GenMessage<PullRequestStat> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 11);

/**
 * ReportPrStatsRequest is sent by the CLI to push PR speed metrics.
 *
 * @generated from message gitpod.v1.ReportPrStatsRequest
 */
export type ReportPrStatsRequest = Message<"gitpod.v1.ReportPrStatsRequest"> & {
  /**
   * Project that was analyzed.
   *
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * Per-PR stats to upsert. May be empty to act as a heartbeat that
   * updates last_workflow_run without persisting data.
   *
   * @generated from field: repeated gitpod.v1.PullRequestStat stats = 2;
   */
  stats: PullRequestStat[];
};

/**
 * Describes the message gitpod.v1.ReportPrStatsRequest.
 * Use `create(ReportPrStatsRequestSchema)` to create a new message.
 */
export const ReportPrStatsRequestSchema: GenMessage<ReportPrStatsRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 12);

/**
 * @generated from message gitpod.v1.ReportPrStatsResponse
 */
export type ReportPrStatsResponse = Message<"gitpod.v1.ReportPrStatsResponse"> & {
  /**
   * Number of rows inserted (new PRs).
   *
   * @generated from field: int64 inserted_count = 1;
   */
  insertedCount: bigint;

  /**
   * Number of rows updated (re-reported PRs).
   *
   * @generated from field: int64 updated_count = 2;
   */
  updatedCount: bigint;
};

/**
 * Describes the message gitpod.v1.ReportPrStatsResponse.
 * Use `create(ReportPrStatsResponseSchema)` to create a new message.
 */
export const ReportPrStatsResponseSchema: GenMessage<ReportPrStatsResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 13);

/**
 * GetInsightsSummaryRequest returns project-level insights adoption for the org.
 *
 * @generated from message gitpod.v1.GetInsightsSummaryRequest
 */
export type GetInsightsSummaryRequest = Message<"gitpod.v1.GetInsightsSummaryRequest"> & {
  /**
   * Organization to query.
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;
};

/**
 * Describes the message gitpod.v1.GetInsightsSummaryRequest.
 * Use `create(GetInsightsSummaryRequestSchema)` to create a new message.
 */
export const GetInsightsSummaryRequestSchema: GenMessage<GetInsightsSummaryRequest> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 14);

/**
 * @generated from message gitpod.v1.GetInsightsSummaryResponse
 */
export type GetInsightsSummaryResponse = Message<"gitpod.v1.GetInsightsSummaryResponse"> & {
  /**
   * Number of projects with insights enabled.
   *
   * @generated from field: int64 enabled_project_count = 1;
   */
  enabledProjectCount: bigint;

  /**
   * Total number of projects in the organization.
   *
   * @generated from field: int64 total_project_count = 2;
   */
  totalProjectCount: bigint;
};

/**
 * Describes the message gitpod.v1.GetInsightsSummaryResponse.
 * Use `create(GetInsightsSummaryResponseSchema)` to create a new message.
 */
export const GetInsightsSummaryResponseSchema: GenMessage<GetInsightsSummaryResponse> = /*@__PURE__*/
  messageDesc(file_gitpod_v1_insights, 15);

/**
 * ScmProvider identifies the SCM platform a pull request was fetched from.
 *
 * @generated from enum gitpod.v1.ScmProvider
 */
export enum ScmProvider {
  /**
   * @generated from enum value: SCM_PROVIDER_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * GitHub.
   *
   * @generated from enum value: SCM_PROVIDER_GITHUB = 1;
   */
  GITHUB = 1,

  /**
   * GitLab.
   *
   * @generated from enum value: SCM_PROVIDER_GITLAB = 2;
   */
  GITLAB = 2,

  /**
   * Bitbucket.
   *
   * @generated from enum value: SCM_PROVIDER_BITBUCKET = 3;
   */
  BITBUCKET = 3,
}

/**
 * Describes the enum gitpod.v1.ScmProvider.
 */
export const ScmProviderSchema: GenEnum<ScmProvider> = /*@__PURE__*/
  enumDesc(file_gitpod_v1_insights, 0);

/**
 * InsightsService provides AI code attribution analytics for projects.
 * The CLI reports per-commit co-author data from git history, and the
 * dashboard reads aggregated stats.
 *
 * @generated from service gitpod.v1.InsightsService
 */
export const InsightsService: GenService<{
  /**
   * Reports co-author analysis results from a project's git history.
   * Accepts a batch of per-commit stats. Writes are idempotent: re-reporting
   * the same commit (project_id + commit_hash) overwrites the previous row.
   *
   * @generated from rpc gitpod.v1.InsightsService.ReportCoAuthorStats
   */
  reportCoAuthorStats: {
    methodKind: "unary";
    input: typeof ReportCoAuthorStatsRequestSchema;
    output: typeof ReportCoAuthorStatsResponseSchema;
  },
  /**
   * Enables co-author insights for a project. Idempotent.
   *
   * @generated from rpc gitpod.v1.InsightsService.EnableProjectInsights
   */
  enableProjectInsights: {
    methodKind: "unary";
    input: typeof EnableProjectInsightsRequestSchema;
    output: typeof EnableProjectInsightsResponseSchema;
  },
  /**
   * Disables co-author insights for a project. Idempotent.
   * Removes the associated workflow (if any) and sets enabled to false.
   *
   * @generated from rpc gitpod.v1.InsightsService.DisableProjectInsights
   */
  disableProjectInsights: {
    methodKind: "unary";
    input: typeof DisableProjectInsightsRequestSchema;
    output: typeof DisableProjectInsightsResponseSchema;
  },
  /**
   * Returns whether co-author insights is enabled for a project.
   *
   * @generated from rpc gitpod.v1.InsightsService.GetProjectInsightsStatus
   */
  getProjectInsightsStatus: {
    methodKind: "unary";
    input: typeof GetProjectInsightsStatusRequestSchema;
    output: typeof GetProjectInsightsStatusResponseSchema;
  },
  /**
   * Reports PR speed metrics collected from SCM APIs.
   * Accepts a batch of per-PR stats. Writes are idempotent: re-reporting
   * the same PR (project_id + pr_number) overwrites the previous row.
   *
   * @generated from rpc gitpod.v1.InsightsService.ReportPrStats
   */
  reportPrStats: {
    methodKind: "unary";
    input: typeof ReportPrStatsRequestSchema;
    output: typeof ReportPrStatsResponseSchema;
  },
  /**
   * Reports an agent trace session for a project environment.
   * Stores the raw trace alongside denormalized line-change totals.
   *
   * @generated from rpc gitpod.v1.InsightsService.ReportAgentTrace
   */
  reportAgentTrace: {
    methodKind: "unary";
    input: typeof ReportAgentTraceRequestSchema;
    output: typeof ReportAgentTraceResponseSchema;
  },
  /**
   * Returns how many projects have insights enabled vs total projects in the org.
   *
   * @generated from rpc gitpod.v1.InsightsService.GetInsightsSummary
   */
  getInsightsSummary: {
    methodKind: "unary";
    input: typeof GetInsightsSummaryRequestSchema;
    output: typeof GetInsightsSummaryResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_gitpod_v1_insights, 0);

